import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createEventHorsesSchemas } from 'shared/db/validation/schema/eventHorses';
import { Validator } from 'shared/db/validation/validator';
import {
    EventHorseRawRecord,
    EventHorseUpdateRawRecord,
} from 'shared/types/EventHorse';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { EventHorsesDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createEventHorsesSchemas();

const addValidator = createDBEntityValidator<EventHorseRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<EventHorseUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-event-horses'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createEventHorsesInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const eventHorsesInputValidation: EventHorsesDBValidation = {
    add: createEventHorsesInputValidation(addValidator, validationStrategy),
    update: createEventHorsesInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createEventHorsesInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
